import * as Clarity from '@microsoft/react-native-clarity';

class ClarityManager {
  private initialized = false;
  private paused = true;
  private projectId: string | null = null;

  init(projectId: string) {
    if (this.initialized) return;
    this.projectId = projectId;
    Clarity.initialize(projectId);
    this.initialized = true;
    this.paused = false;
  }

  pause() {
    if (!this.initialized || this.paused) return;
    Clarity.pause();
    this.paused = true;
  }

  resume() {
    if (!this.initialized || !this.paused) return;
    Clarity.resume();
    this.paused = false;
  }

  get active() {
    return this.initialized && !this.paused;
  }
}

export const clarityManager = new ClarityManager();
